import React from 'react';
import { Twitter, Instagram, Facebook, Youtube, Mail } from 'lucide-react';
import { socialMediaLinks } from '../../config/social';

const Footer = () => {
  return (
    <div className="bg-slate-950 py-6">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col items-center">
          <p className="theme-text-secondary text-sm italic mb-6">
            Built for FPL nerds. Normal people were not harmed in the making.
          </p>
          
          <div className="flex items-center justify-center space-x-8">
            <a 
              href="mailto:hello@footydrafthub.com"
              className="flex items-center gap-2 theme-text-secondary hover:text-[var(--color-primary)] theme-transition text-sm"
              title="Contact Us"
            >
              <Mail className="w-5 h-5" />
              hello@footydrafthub.com
            </a>
            <a 
              href={socialMediaLinks.twitter}
              target="_blank" 
              rel="noopener noreferrer"
              className="theme-text-secondary hover:text-[var(--color-primary)] theme-transition"
            >
              <Twitter className="w-6 h-6" />
            </a>
            <a 
              href={socialMediaLinks.instagram}
              target="_blank" 
              rel="noopener noreferrer"
              className="theme-text-secondary hover:text-[var(--color-primary)] theme-transition"
            >
              <Instagram className="w-6 h-6" />
            </a>
            <a 
              href={socialMediaLinks.facebook}
              target="_blank" 
              rel="noopener noreferrer"
              className="theme-text-secondary hover:text-[var(--color-primary)] theme-transition"
            >
              <Facebook className="w-6 h-6" />
            </a>
            <a 
              href={socialMediaLinks.youtube}
              target="_blank" 
              rel="noopener noreferrer"
              className="theme-text-secondary hover:text-[var(--color-primary)] theme-transition"
            >
              <Youtube className="w-6 h-6" />
            </a>
          </div>
          
          <div className="text-center mt-4 theme-text-muted text-sm">
            © {new Date().getFullYear()} Footy Draft Hub. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer; 